// TODO rename file to jsx file and move into components->globalComponents
import React, { Component } from 'react';
import { InputText } from 'primereact/components/inputtext/InputText';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Menubar } from 'primereact/menubar';
import MessageService from '../../service/MessageService';
import { configVersion } from '../../utils/configUtils';

const { ENVIRONMENT } = window;
const VERSION = configVersion[ENVIRONMENT];

export default class AppTopbar extends Component {
  constructor() {
    super();
    this.messageService = new MessageService();
    this.onLogoutClick = this.onLogoutClick.bind(this);
    this.onHide = this.onHide.bind(this);
    this.state = {
      visible: false,
      logoutId: 'dummy',

      items: [
        {
          label: 'Hilfe',
          icon: 'pi-md-help',
        },
        {
          label: 'FAQ',
          icon: 'pi-md-book',
        },
        {
          label: VERSION,
          icon: 'pi-md-turned-in-not',
        },
      ],
    };
  }

  onLogoutClick() {
    this.setState({ visible: true });
  }

  onHide() {
    this.setState({ visible: false });
  }

  render() {
    const { logoutId } = this.state;
    const { items } = this.state;
    const { visible } = this.state;
    const footer = (
      <div>
        <Button
          label="Ja"
          id="yes"
          icon="pi pi-check"
          onClick={() => this.messageService.postUserLogout(logoutId)}
        />
        <Button
          label="Nein"
          id="no"
          icon="pi pi-times"
          onClick={this.onHide}
          className="p-button-danger"
        />
      </div>
    );

    return (
      <div>
        <div className="content-section implementation">
          <Menubar
            model={items}
            style={{ backgroundColor: '#ffb300', padding: '6px' }}
          >
            <InputText
              id="searchTopbar"
              placeholder="Suchen"
              type="text"
              style={{ color: '#757575', backgroundColor: '#F5F5F5' }}
            />
            <Button
              label="Abmeldung"
              id="logout"
              icon="pi-md-exit-to-app"
              className="p-button-danger"
              style={{ marginLeft: 4 }}
              onClick={this.onLogoutClick}
            />
          </Menubar>
          <Dialog
            header="Abmeldung"
            visible={visible}
            style={{ width: '40vw' }}
            footer={footer}
            onHide={this.onHide}
            modal
          >
            <p>
              Sind Sie sich sicher, dass Sie sich abmelden wollen? Alle bisher
              ungespeicherten Daten gehen unwiderruflich verloren.
            </p>
          </Dialog>
        </div>
      </div>
    );
  }
}
